import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl, headersDefault } from ".";
import axios from "axios";

// Async Thunk to fetch slides
export const fetchPreLoginSlides = createAsyncThunk(
  "preLogin/fetchSlides",
  async (_, { rejectWithValue }) => {
    console.log("here");
    try {
      // Adjust the URL if your request helper doesn't handle the base URL
      const response = await axios.get(`${baseUrl}/api/app/images/pre-login`, {
        headers: headersDefault(),
      });
      console.log("response", response);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching slides");
    }
  }
);
